import React, { useEffect, useRef, useState } from "react";
import { isIOS } from "react-device-detect";
import { ImageString } from "../../const/assets/ImageString";
import { gameScores } from "../../const/fixed/Types";
import { menuItems, menuItemsId, menuItemsIndex } from "../../const/Menu/MenuConst";
import { addRealtimeHotspotAnalytics, updateUserLocation } from "../firebase/firebase";
import { AiOutlineArrowDown } from 'react-icons/ai'
const treasure = [
  "treasure1",
  "treasure2",
  "treasure3",
  "treasure4",
  "treasure5",
  "treasure6",
  "treasure7",
  "treasure8",
];
function Game(props) {
  const [timer, setTimer] = useState(120);
  const timeref = useRef();
  const timeOutRef = useRef();
  useEffect(() => {
    updateUserLocation(props.context, "Treasurehunt")
    addRealtimeHotspotAnalytics(props.context, "Treasurehunt")
    return () => {
      clearInterval(timeref.current);
      clearTimeout(timeOutRef.current);
    };
  }, []);

  useEffect(() => {
    if (props.endGameScreen) {
      clearInterval(timeref.current);
      if (window.parent.addRemainingTime) {
        window.parent.addRemainingTime(timer);
        console.log(timer);
      }
    }
  }, [props.endGameScreen]);

  const getTime = (time) => {
    let r = time % 60;
    let d = Math.floor(time / 60);
    return `${d}:${r < 10 ? "0" + r : r}`;
  };
  return (
    <>
      {props.startGameScreen && (
        <div className="lobbyTutContainer">
          <div className="tut-box game-inst">
            {!isIOS && <div className="d-arrow" onClick={() => {
              document.querySelector('.scroll-div').scrollIntoView({ behavior: 'smooth' })
            }}><AiOutlineArrowDown /></div>}
            <img
              src={ImageString.CLOSEBUTTON}
              className="closeButton-mediaModal"
              alt="MediaModalCLoseButton"
              style={{
                position: "absolute",
                right: 0,
                top: 0,
                width: "3rem",
                margin: '1rem',
                boxShadow: 'unset'
              }}
              onClick={(e) => { props.handleClick(e, menuItems[menuItemsIndex.Lobby]) }}
            ></img>
            <div className="head">
              <img src="/assets/images/login/game-logo.png" alt="" />
            </div>
            <div className="content">
              <h2>Game Instructions:</h2>
              <br />
              <p>( Scroll to view all the instructions )</p>
              <br />
              <div className="inst">
                <div>
                  <img src="/assets/images/login/8hunt.png" alt="" />
                  <p>There are 8 hidden treasures in the space.</p>
                </div>
                <div>
                  <img src="/assets/images/login/40s.png" alt="" />
                  <p>You have 120 seconds to collect the hidden treasures.</p>
                </div>
                <div>
                  <img src="/assets/images/login/t-logo.png" alt="" />
                  <p>Each treasure collected will add to the leaderboard.</p>
                </div>
                <div>
                  <img src="/assets/images/login/gr-ring.png" alt="" />
                  <p>
                    You have to look for this icon to gain 100 points. <br /> Click around the area and find the hidden circles.
                  </p>
                </div>
                <div>
                  <img src="/assets/images/login/g-ring.png" alt="" />
                  <p>
                    You have to look for this icon to gain 200 points. <br /> Click around the area and find the hidden circles.
                  </p>
                </div>
                <div>
                  <img src="/assets/images/login/cut-off.png" alt="" />
                  <p>
                    <strong>Cut Off 8 PM </strong> - Prizes to be given to the Top 5 players.
                  </p>
                </div>
                <div className="scroll-div"></div>
              </div>
            </div>
            <div className="box-button">
              <button
                onClick={() => {
                  props.updatePlayedCount();
                  props.stratScreneState(false);
                  timeref.current = setInterval(() => {
                    setTimer((prev) => prev - 1);
                  }, 1000);
                  timeOutRef.current = setTimeout(() => {
                    props.endScreenState(true);
                    clearInterval(timeref.current);
                  }, 120000);
                }}
              >
                Let’s Go
              </button>
            </div>
          </div>
        </div>
      )}
      <iframe
        id="game-frame"
        src="/hunt_game/index.htm"
        frameBorder="0"
        style={{
          height: "100%",
          width: "100%",
          zIndex: 2,
          position: "absolute",
          display:
            props.currentMenuItem === menuItemsId.Game ? "block" : "none",
        }}
        className={`"main-frame" ${isIOS ? "lobby-ios" : ""}`}
      ></iframe>
      {props.endGameScreen && (
        <div className="lobbyTutContainer">
          <div className="tut-box game-inst e-s-t">
            <div className="head">
              <img src="/assets/images/login/game-logo.png" alt="" />
            </div>
            <div className="content">
              <div className="inst-l-s">
                <h1>
                  Your <br /> Score
                </h1>
                <h1>{props.myScore}</h1>
              </div>
            </div>
            <div className="box-button">
              <button onClick={props.backButton}>Back to Lobby</button>
            </div>
          </div>
        </div>
      )}

      <div
        className={`${!props.startGameScreen && "visible-g"} game-dashboard`}
      >
        <img src="/assets/images/login/d-logo.png" alt="" className="d-logo" />
        <div className="timer-div">
          {/* <img src="/assets/images/login/clock.png" alt="" /> */}
          <p>{getTime(timer)}</p>
        </div>
        <span className="d-line"></span>
        <div className="d-items">
          {treasure.map((item, pos) => {
            return (
              <div key={item} id={item}>
                <img src={`/assets/images/login/${item}.png`} alt="" />
                <div className="details">
                  <p>{gameScores[`${item}`]}</p>
                  <img src="/assets/images/login/collected.png" alt="" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default Game;
